module.exports = __webpack_public_path__ + "img/ford-mustang.2a34c6e3.jpg";